import app from 'flarum/forum/app';
import addNavLink from './addNavLink';
export { default as extend } from './extend';
app.initializers.add('champis-exhibitions', () => {
  addNavLink();
});